<template>
  <div>
    <cabecalho title="ACADEMICO_MATRICULAS.DADOS_ALUNO" title_type="body" />

    <p><b>Código Matrícula:</b> {{ matricula.codigoMatricula }}</p>

    <div class="row ml-1">
      <div class="row col-12 col-md-2 mt-2">
        <img
          alt="foto aluno"
          :src="fotoAluno"
          class="sem-foto-aluno cover"
          ref="zoomImage"
        />
      </div>
      <div class="row col-12 col-md-10">
        <div class="col-12 col-md-10">
          <input-text label="Nome" v-model="aluno.nome" type="text" disabled />
        </div>
        <div class="col-12 col-md-2">
          <input-text
            label="Data de Nascimento"
            :value="dataNascimentoFormatada"
            type="text"
            disabled
          />
        </div>

        <div class="col-12 col-md-4">
          <input-text
            label="Identidade"
            v-model="aluno.identidade"
            type="text"
            disabled
          />
        </div>
        <div class="col-12 col-md-4">
          <input-text
            label="Órgão expedidor"
            v-model="aluno.orgaoExpedidor"
            type="text"
            disabled
          />
        </div>
        <div class="col-12 col-md-4">
          <input-text
            label="Data de expedição"
            :value="dataExpedicaoFormatada"
            type="text"
            disabled
          />
        </div>

        <div class="col-12 col-md-4">
          <input-text label="CPF" v-model="aluno.cpf" type="text" disabled />
        </div>
        <div class="col-12 col-md-4">
          <input-text
            label="Registro de Nascimento"
            v-model="aluno.registroNascimento"
            type="text"
            disabled
          />
        </div>
        <div class="col-12 col-md-4">
          <input-text
            label="Instituição de origem:"
            v-model="matricula.escolaOrigemNome"
            type="text"
            disabled
          />
        </div>
        <div class="col-12 col-md-4">
          <input-text
            type="text"
            label="Nacionalidade"
            v-if="nacionalidade"
            v-model="aluno.nacionalidade.nome"
            disabled
          />
        </div>

        <div class="col-12 col-md-6 mt-2">
          <input-text
            :label="$t('PESSOAS.IDENTIFICADOR_CENSO')"
            v-model="aluno.identificadorCenso"
            type="text"
            disabled
          />
        </div>
        <div class="col-12">
          <small>* Dados apenas para visualização.</small>
        </div>
        <div class="col-12 mt-4">
          <div class="row">
            <div class="col">
              <cabecalho
                title="ACADEMICO_MATRICULAS.OBSERVACOES"
                title_type="body"
              />
            </div>
            <div class="col-12">
              <input-text-area
                ref="observacoes"
                v-model="matricula.observacao"
                :maxLength="1000"
                :label="$t('ACADEMICO_MATRICULAS.OBSERVACOES_LABEL')"
                disabled
              />
            </div>
          </div>
        </div>
        <div class="col-12 mt-4">
          <div class="row">
            <div class="col">
              <cabecalho
                title="ACADEMICO_MATRICULAS.OBSERVACOES_GERAIS"
                title_type="body"
              />
            </div>
            <div class="col-12">
              <input-text-area
                ref="observacoesGerais"
                v-model="matricula.observacoesGerais"
                :maxLength="1000"
                :label="$t('ACADEMICO_MATRICULAS.OBSERVACOES_GERAIS_LABEL')"
                disabled
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// Utils & Aux:
import rotas from '@/common/utils/rotas';
import helpers from '@/common/utils/helpers';

// Components:
import { Cabecalho } from '@/components/headers/index';
import { InputText, InputTextArea } from '@/components/inputs';
import mediumZoom from 'medium-zoom';

export default {
  props: {
    matricula: { type: Object, default: Object },
    aluno: { type: Object, default: Object },
    foto: { type: String, default: null },
  },
  components: {
    Cabecalho,
    InputText,
    InputTextArea,
  },
  computed: {
    fotoAluno() {
      return this.foto ? this.foto : this.semFoto;
    },
    dataNascimentoFormatada() {
      if (this.aluno.dataNascimento)
        return helpers.formatarDataBr(this.aluno.dataNascimento);
      return null;
    },
    dataExpedicaoFormatada() {
      if (this.aluno.dataExpedicao)
        return helpers.formatarDataBr(this.aluno.dataExpedicao);
      return null;
    },
  },
  data() {
    return {
      nacionalidade: '',
      semFoto: require('@/assets/images/users/user-photo-input.png'),
    };
  },
  mounted() {
    this.$nextTick(() => {
      mediumZoom(this.$refs.zoomImage, {
        margin: 20, // Espaço ao redor da imagem
        background: '#000', // Fundo ao ativar o zoom
        scrollOffset: 40, // Ajuste de rolagem para fechar
      });
    });
  },

  methods: {
    irPara(rota, id) {
      rotas.irPara(rota, id);
    },
    // buscarFoto() {
    //   if (this.$route.params.id !== undefined) {
    //     this.$store.dispatch(START_LOADING);
    //     PessoaService.getFoto(this.id)
    //       .then(({ data }) => {
    //         this.fotoExistente = 'data:image/jpeg;base64,' + data.documento;
    //         this.fotoNome = data.nomeArquivo;
    //       })
    //       .catch(() => {
    //         // mensagem.showErrors(err);
    //       })
    //       .finally(() => {
    //         this.$store.dispatch(STOP_LOADING);
    //       });
    //   }
    // },
  },
};
</script>

<style>
.foto-aluno {
  border: solid 1px #000;
  max-width: 100%;
  max-height: 180px;
  background: gray;
  display: block;
  object-fit: cover;
  cursor: pointer;
}
.sem-foto-aluno {
  border: solid 1px #000;
  max-width: 150px;
  max-height: 150px;
  background: gray;
  display: block;
  object-fit: cover;
}
.foto-aluno-modal {
  border: solid 1px #000;
  max-width: 250px;
  max-height: 250px;
  background: gray;
  display: block;
  object-fit: cover;
}
.medium-zoom-overlay {
  z-index: 99;
  background: rgb(0 0 0 / 83%) !important;
}
.medium-zoom-image--opened {
  z-index: 9999;
}
</style>
